import Glightbox from 'glightbox';

export default class Lightbox {
    constructor() {
        this.events();
    }

    events() {
        this.handleLightbox();
    }

    handleLightbox() {
        // eslint-disable-next-line no-unused-vars
        const lightbox = new Glightbox({
            selector: '.jsLightbox',
            touchNavigation: true,
            loop: true,
        });
    }
}
